<template>
  <div>
    <page-title icon="fa fa-shopping-cart" main="Produtos" sub="Pesquisar Produtos"
    :help="true" titleHelp="Ajuda - Produtos"
    content="Página responsável por listar produtos ligados ao banco ERP possibilitando também busca por filtros."
    >
      <template v-slot:actions>
        <base-button
          @click="product = {}, modals.modal0 = true"
          type="neutral"
          class="ml-3"
          size="sm"
        >Novo Produto</base-button>
      </template>
    </page-title>
    <go-back-modal :title="goBackModalTitle" :open="openGoBackModal" />
    <modal :show.sync="modals.modal0" id="cadastrar-product" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Cadastrar Novo Produto</h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-md-6">
              <base-input
                group class="mb-3"
                type="text"
                :required="true"
                placeholder="Nome do Produto"
                label="Nome do Produto"
                v-model="product.description"
                aria-label="Nome do Produto"
                @input="errors.description = null"
                >
              </base-input>
              <div v-if="errors.description " class="invalid-feedback" style="display: block;">
               {{ errors.description  }}
              </div>
            </div>
            <div class="col-md-6">
              <base-input
                  group class="mb-3"
                  type="text"
                  :required="true"
                  placeholder="Marca do Produto"
                  label="Marca do Produto"
                  v-model="product.brand"
                  :options="products_brands"
                  aria-label="Marca do Produto"
                  @input="errors.brand = null"
                >
              </base-input>
              <div v-if="errors.brand " class="invalid-feedback" style="display: block;">
               {{ errors.brand  }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <base-input
                  group class="mb-3"
                  :required="true"
                  type="text"
                  placeholder="Unidade de Medida"
                  label="Unidade de Medida"
                  v-model="product.unity"
                  aria-label="Unidade de Medida"
                  @input="errors.unity = null"
                >
              </base-input>
              <div v-if="errors.unity " class="invalid-feedback" style="display: block;">
               {{ errors.unity  }}
              </div>
            </div>
            <div class="col-md-6">
              <base-input
                  group class="mb-2"
                  :required="true"
                  type="text"
                  placeholder="Peso/Quantidade do produto"
                  label="Peso/Quantidade do produto"
                  v-model="product.weight"
                  aria-label="Peso/Quantidade do produto"
                  @input="errors.weight = null"
                >
              </base-input>
              <div v-if="errors.weight " class="invalid-feedback" style="display: block;">
               {{ errors.weight  }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
                <label class="form-control-label">Tipo</label>
                <multiselect
                  v-model="product.producttype_id"
                  :options="products_type"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  placeholder="Selecionar Tipo"
                  label="descricao"
                  track-by="id"
                  :allow-empty="true"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('type')"
                  @input="errors.producttype_id = null"
                ></multiselect>
              <div v-if="errors.producttype_id " class="invalid-feedback" style="display: block;">
               {{ errors.producttype_id  }}
              </div>
            </div>
            <div class="col-md-4">
                <label class="form-control-label">Grupo</label>
                <multiselect
                  v-model="product.grupo_id"
                  :options="grupos"
                  placeholder="Selecionar Grupo"
                  label="descricao"
                  track-by="id"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  :allow-empty="true"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('group')"
                  @input="errors.grupo_id = null"
                ></multiselect>
              <div v-if="errors.grupo_id " class="invalid-feedback" style="display: block;">
               {{ errors.grupo_id  }}
              </div>
            </div>
            <div class="col-md-4">
                <label class="form-control-label">Sub-Grupo</label>
                <multiselect
                  v-model="product.subgrupo_id"
                  :options="subgrupos"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  placeholder="Selecionar Sub-Grupo"
                  label="descricao"
                  track-by="id"
                  :allow-empty="true"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('subgroup')"
                  @input="errors.subgrupo_id = null"
                ></multiselect>
              <div v-if="errors.subgrupo_id " class="invalid-feedback" style="display: block;">
               {{ errors.subgrupo_id  }}
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false">Fechar</base-button>
        <base-button type="success" @click="save">Salvar e continuar</base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal1" id="editar-product" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Editar Produto Existente</h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-md-6">
              <base-input
                group class="mb-3"
                type="text"
                :required="true"
                placeholder="Nome do Produto"
                label="Nome do Produto"
                v-model="formProduct.description"
                aria-label="Nome do Produto"
                success-message="Campo preenchido"
                :error="errors[0]"
              />
            </div>
            <div class="col-md-6">
              <base-input
                group class="mb-3"
                type="text"
                :required="true"
                placeholder="Marca do Produto"
                label="Marca do Produto"
                v-model="formProduct.brand"
                :options="products_brands"
                aria-label="Marca do Produto"
                rules="required"
                success-message="Campo preenchido"
                :error="errors[0]"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <base-input
                group class="mb-3"
                :required="true"
                type="text"
                placeholder="Unidade de Medida"
                label="Unidade de Medida"
                v-model="formProduct.unity"
                aria-label="Unidade de Medida"
                rules="required"
                success-message="Campo preenchido"
                :error="errors[0]"
              />
            </div>
            <div class="col-md-6">
              <base-input
                group class="mb-2"
                :required="true"
                type="text"
                placeholder="Peso/Quantidade do produto"
                label="Peso/Quantidade do produto"
                v-model="formProduct.weight"
                aria-label="Peso/Quantidade do produto"
                rules="required"
                success-message="Campo preenchido"
                :error="errors[0]"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <label class="form-control-label">Tipo</label>
              <multiselect
                v-model="formProduct.producttype"
                :options="products_type"
                placeholder="Selecionar Tipo"
                label="descricao"
                track-by="id"
                :allow-empty="true"
                :block-keys="['Tab', 'Enter']"
                @close="onTouch('type')"
              ></multiselect>
            </div>
            <div class="col-md-4">
              <label class="form-control-label">Grupo</label>
              <multiselect
                v-model="formProduct.grupo"
                :options="grupos"
                placeholder="Selecionar Grupo"
                label="descricao"
                track-by="id"
                :allow-empty="true"
                :block-keys="['Tab', 'Enter']"
                @close="onTouch('group')"
              ></multiselect>
            </div>
            <div class="col-md-4">
              <label class="form-control-label">Sub-Grupo</label>
              <multiselect
                v-model="formProduct.subgrupo"
                :options="subgrupos"
                placeholder="Selecionar Sub-Grupo"
                label="descricao"
                track-by="id"
                :allow-empty="true"
                :block-keys="['Tab', 'Enter']"
                @close="onTouch('subgroup')"
              ></multiselect>
            </div>
          </div>       
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal1 = false">Fechar</base-button>
        <base-button type="success" @click="execEdit">Salvar</base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal2" id="vincular-culturas" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Vincular Culturas</h5>
      </template>
      <form-culture
        v-bind="$attrs" 
        v-on="$listeners"
        ref="formCulture"
        :product-cultures="productCultures"
        :product="product"
        :cultures="cultures"
        :right-items="paginatedRightItems.currentPageItems"
        :is-modal-open="modals.modal2"
        :all-right-cultures="allRightCultures"
        @search-action-left="searchEventLeft($event, product.id)"
        @search-action-right="searchEventRight"
        @cultures-saved="setData"
        @remove-culture="removeCultures"
        @update-cultures="updateAllRightCultures"
      />
      <div class="row">
        <div class="col-md-6">
          <div slot="footer" class="py-4 justify-content-end">
            <base-pagination
              v-on:input="changePageLeft(product.id, $event, filterCultures)"
              v-model="paginated_cultures_left['current']"
              :total="paginated_cultures_left['count']"
              :perPage="paginated_cultures_left['per_page']"
            ></base-pagination>
          </div>
        </div>
        <div class="col-md-6">
          <div slot="footer" class="py-4 d-flex justify-content-end">
            <base-pagination
              v-on:input="changePageRight"
              v-model="paginatedRightItems.currentPage"
              :total="paginatedRightItems.totalItems"
              :perPage="paginatedRightItems.itemsPerPage"
            />
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="success" @click="saveCultures">Salvar</base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal3" id="similar-products" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Vincular Produtos Similares</h5>
      </template>
      <template>
        <vue-list-picker
          v-on:move-right="adicionarSimilar(product.id ,$event)"
          v-on:move-left="removerSimilar(product.id ,$event)"
          v-on:move-all-right="adicionarSimilar(product.id ,$event)"
          v-on:move-all-left="removerSimilar(product.id ,$event)"
          :left-items="similarProducts"
          :right-items="similarProductsRight"
          :content-key="'id'"
          :content-attr="'description'"
          :title-left="'PRODUTOS'"
          :title-right="product.description"
          :content-class="'itensGrupos'"
          :title-class="'tituloGrupos'"
          :button-class="'btn btn-success button-class'"
          :leftSearch="true"
          v-on:search-action-left="searchSimilarLeft($event, product.id)"
          :rightSearch="true"
          v-on:search-action-right="searchSimilarRight($event, product.id)"
          />
      </template>
      <div class="row">
        <div class="col-md-6">
          <div slot="footer" class="py-4 justify-content-end">
            <base-pagination
              v-on:input="changePageSimilarLeft(product.id, $event, filterSimilarLeft)"
              v-model="paginated_products_left['current']"
              :total="paginated_products_left['count']"
              :perPage="paginated_products_left['per_page']"
            ></base-pagination>
          </div>
        </div>
        <div class="col-md-6">
          <div slot="footer" class="py-4 d-flex justify-content-end">
            <base-pagination
              v-on:input="changePageSimilarRight(product.id ,$event, filterSimilarRight)"
              v-model="paginated_products_right['current']"
              :total="paginated_products_right['count']"
              :perPage="paginated_products_right['per_page']"
            ></base-pagination>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="success" @click="modals.modal3 = false, product = {}">Salvar</base-button>
      </template>
    </modal>
    <card>
      <div slot="header">
        <span>Pesquisar Produtos</span>
      </div>
      <form>
        <div class="row">
          <div class="col-md-3">
            <div>
              <label class="form-control-label">Código do Produto</label>
              <multiselect
                v-model="filter.product"
                :options="productList"
                placeholder="Selecionar Codigo"
                label="code"
                track-by="code"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :loading="loadingMore"
                @search-change="(search) => fetchProductOptions(search || '', true)"
                @bottom-reached="() => fetchProductOptions(currentSearchTerm)"
              ></multiselect>
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <label class="form-control-label">Marca do Produto</label>
              <multiselect
                v-model="filter.brand"
                :options="products_brands"
                placeholder="Selecionar Marca"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
              ></multiselect>
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <label class="form-control-label">Tipo do Produto</label>
               <div :class="{ 'invalid': typeIsInvalid }">
                <multiselect
                  v-model="filter.producttype_id"
                  :options="products_type"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  placeholder="Selecionar Tipo"
                  :style="{position: 'relative'}"
                  label="descricao"
                  track-by="id"
                  :allow-empty="true"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('type')"
                ></multiselect>
               </div>
            </div>
          </div>
           <div class="col-md-3">
            <div>
              <label class="form-control-label">Grupo</label>
              <multiselect
                v-model="filter.grupo_id"
                :options="grupos"
                placeholder="Selecionar Grupo"
                label="descricao"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                track-by="id"
                @input="filterSubgroups"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-3">
            <div>
              <label class="form-control-label">Subgrupo</label>
              <multiselect
                v-model="filter.subgrupo_id"
                :options="filteredSubgroups"
                placeholder="Selecionar Sub-Grupo"
                label="descricao"
                track-by="id"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
              ></multiselect>
            </div>
          </div>
          <div class="col-md-3">
           <label class="form-control-label">Status</label>
            <multiselect
              v-model="filter.selectedStatus"
              :options="filterStatuses"
              select-label=""
              deselect-label=""
              selected-label=""
              placeholder="Selecionar Status"
              label="label"
              track-by="value"
              :allow-empty="true"
              :preserveSearch="true"
            >
              <template v-slot:noResult>Nenhum Resultado Encontrado</template>
            </multiselect>
          </div>
           <div class="col-md-3">
            <base-input label="Descrição" v-model="filter.description"></base-input>
          </div>
          <div class="ml-3 pb-2" style="margin-top: 2rem; position: relative;">
            <clear-filters-button v-on:clearFilters="clearFilters"></clear-filters-button>
              <base-button type="primary" style="width: 8rem; max-height: 3rem;"  @click="search"> Filtrar </base-button>
            </div>
        </div>
      </form>
      <el-table
        v-loading="isLoading"
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="products"
        ref="products"
      >
        <el-table-column label="Código" min-width="90px" prop="code" sortable></el-table-column>
        <el-table-column label="Descrição" min-width="180px" prop="description" sortable></el-table-column>
        <el-table-column label="Tipo" min-width="150px" prop="producttype.descricao" sortable></el-table-column>
        <el-table-column label="Grupo" min-width="110px" prop="grupo.descricao" sortable></el-table-column>
        <el-table-column label="Ações" min-width="130px" prop="acoes" v-slot="{row}">
          <div class="row">
            <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
                <a class="dropdown-item" href="#" @click="edit(row, 'culture')">Vincular Culturas</a>
                <a class="dropdown-item" href="#" @click="edit(row, 'similar')">Vincular Produtos Similares</a>
                <a class="dropdown-item" href="#" @click="remove(row)">Excluir</a>
              </el-dropdown-menu>
            </el-dropdown>
            <a @click="rowClicked(row, true)">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fa fa-eye mt-2"></i>
              </span>
            </a>
          </div>
        </el-table-column>
        <el-table-column min-width="1px" type="expand">
          <template align="right" slot-scope="props">
            <div class="card-deck" style="white-space: normal;">
              <card>
                <h5 class="card-title">Outras informações</h5>
                  <p>Marca: {{ props.row.brand ? props.row.brand : '' }}</p>
                  <p>Unidade: {{ props.row.unity ? props.row.unity : ''}}</p>
                  <p>Sub-Grupo: {{ props.row.subgrupo ? props.row.subgrupo.descricao : ''}}</p>
                  <p>Peso: {{ props.row.weight ? props.row.weight : '' }}</p>
                  <p>Status: {{ props.row.status ? (props.row.status == "active" ? "Ativo" : "Inativo") : '' }}</p>
                  <p v-for="productPrice in props.row.product_prices" :key="productPrice.id">
                    Preço tabela {{productPrice.price_table.description}}:
                    {{ (productPrice.base_value || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl'}) }}
                  </p>
              </card>
              <card>
                <h5 class="card-title">Vínculos de Cultura</h5>
                <div v-if="rowExpanded.cultures && rowExpanded.cultures.length > 0" class="tags-input__wrapper">
                  <el-tag
                    v-for="(tag, index) in rowExpanded.cultures"
                    :key="tag + index"
                    size="mini"
                    effect="dark"
                    :closable="false"
                    style="margin-right: 2px; margin-bottom: 2px;"
                  >{{tag.description}}</el-tag>
                </div>
                <div v-else class="tags-input__wrapper">
                  <p>Nenhuma cultura vinculada encontrada!</p>
                </div>
              </card>
              <card>
                <h5 class="card-title">Vínculo Produto Preferencial</h5>
                <el-collapse-transition>
                  <div v-if="rowExpanded && rowExpanded.preferredproduct" class="tags-input__wrapper">
                    <p> {{ rowExpanded.preferredproduct.id }} - {{ rowExpanded.preferredproduct.name }}</p>  
                  </div>
                  <div v-else>
                    <p>Nenhum produto preferencial vinculado encontrado!</p>
                  </div>
                </el-collapse-transition>
              </card>
            </div>
          </template>

        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import {
  Tag,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import FormCulture from "./FormCulture.vue";
import ClearFiltersButton from "@/layouts/ClearFiltersButton";
import PageTitle from "@/layouts/PageTitle";
import VueListPicker from "@/components/Vue-list-picker/VueListPicker";
import { ValidationProvider, extend } from "vee-validate";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import GoBackModal from "@/components/GoBackModal.vue";
import { mapState, mapActions } from 'vuex';
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  name: "app",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    FormCulture,
    PageTitle,
    ClearFiltersButton,
    Multiselect,
    ValidationProvider,
    VueListPicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    GoBackModal
  },
  data: ()=>  {
    return {
      modals: {
        modal0: false,
        modal1: false,
        modal2: false,
        modal3: false
      },
      currentPageRight: 1,
      rowExpanded: {},
      productList: [],
      paginated_cultures_left: [],
      paginated_cultures_right: [],
      paginated_products_left: [],
      paginated_products_right: [],
      selectedProducts: [],
      filterSelects: {},
      similarProducts: [],
      similarProductsRight: [],
      allRightCultures: [],
      filter: {
        selectedStatus: { label: "", value: "" },
        code: '',
        brand: '',
        producttype_id: '',
        grupo_id: '',
        subgrupo_id: '',
        status: '',
        description: ''
      },
      debounceTimeout: null,
      filterCultures: {},
      filterCulturesRight: null,
      filterSimilarLeft: {},
      filterSimilarRight: {},
      errors: [],
      rightItems: [],
      cultures: [],
      product: {},
      products_type: [],
      products_brands: [],
      grupos: [],
      errors: {},
      subgrupos: [],
      status: [],
      filteredSubgroups: [],
      filtered: false,
      isTouchedType: false,
      isLoading: false,
      isTouchedGroup: false,
      isTouchedSubgroup: false,
      isFirst:true,
      products: [],
      paginated_data: [],
      filterStatuses: [
        { label: "Ativo", value: "A" },
        { label: "Inativo", value: "I" },
      ],
      productCultures: {
        id: null,
        culture_ids: []
      },
      paginatedFilteredRightItems: [],
      formProduct: {},
      goBackModalTitle: "Produto não encontrado!",
      openGoBackModal: false,
      currentSearchTerm: '',
      lastFetchedSearch: '',
      currentPage: 1,
      loadingMore: false,
      hasMoreResults: true
    };
  },
  mounted() {
    this.getProductTypes();
    this.getGrupos();
    this.getSubgrupos();
    this.getBrands();

    if (this.$route.params.id) {
      this.initRouteProduct(this.$route.params.id);
    } else {
      this.setData();
    }
  },
  methods: {
    ...mapActions(['resetNotificationAction']),
    updateAllRightCultures(cultures) {
      this.allRightCultures = cultures;
    },
    saveCultures() {
      if (this.$refs.formCulture) {
        this.$refs.formCulture.saveCultureToProduct();
      }

      this.modals.modal2 = false;
      this.product = {};
    },
    validateForm(){
      this.errors = {}

      if (!this.product.description) {
        this.errors.description = "Campo Descrição do Produto é obrigatório";
      }
      if (!this.product.brand) {
        this.errors.brand = "Campo Marca do Produto é obrigatório";
      }
      if (!this.product.unity) {
        this.errors.unity = "Campo Unidade de Medida é obrigatório";
      }
      if (!this.product.weight) {
        this.errors.weight = "Campo Peso/Quantidade do Produto é obrigatório";
      }
      if (!this.product.producttype_id) {
        this.errors.producttype_id = "Campo Tipo é obrigatório";
      }
      if (!this.product.grupo_id) {
        this.errors.grupo_id = "Campo Grupo é obrigatório";
      }
      if (!this.product.subgrupo_id) {
        this.errors.subgrupo_id = "Campo Sub-Grupo é obrigatório";
      }

      if (Object.keys(this.errors).length > 0) return false;

      return true;
    },
    async getBrands() {
      try {
        const response = await this.$http.secured.get("/api/v1/productbrands", {})
        this.products_brands = response.data;
      } catch (error) {
        console.error("[Products][getBrands]", error)
      }
    },
    rowClicked(row, ok) {
      if (ok === true) {
        if (this.rowExpanded === row) {
          this.$refs.products.toggleRowExpansion(row, false);
          this.rowExpanded = null;
          return;
        }
        if (this.rowExpanded !== null) {
          this.$refs.products.toggleRowExpansion(
            this.rowExpanded,
            false
          );
        }
        this.$refs.products.toggleRowExpansion(row, true);
        this.rowExpanded = row;
      }
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    async setData(q, page) {
      this.isLoading = true
      try {
        if (typeof page === "undefined") page = null;
        if (typeof q === "undefined" || this.emptyFilter) q = null;
         for (const key in q) {
          if (q[key] == "") {
            delete q[key];
          }
        }
        const response = await this.$http.secured.get("/api/v1/products", {
          params: {
            page: page,
            q: q
          }
        })
        this.paginated_data = response.data;
        if (this.isFirst) {this.productList = this.paginated_data["products"], this.isFirst = false;}       
        this.products = this.paginated_data["products"];
      } catch (error) {
        console.error("[Products][setData]", error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchProductOptions(searchTerm, isNewSearch = false) {
      const isReallyNewSearch = isNewSearch || this.lastFetchedSearch !== searchTerm;

      if (isReallyNewSearch) {
        this.currentSearchTerm = searchTerm;
        this.lastFetchedSearch = searchTerm;
        this.currentPage = 1;
        this.productList = [];
        this.hasMoreResults = true;
      }

      if (!this.hasMoreResults || this.loadingMore) return;

      this.loadingMore = true;

      try {
        let foundEnough = false;

        while (!foundEnough && this.hasMoreResults) {
          if (this.lastFetchedSearch !== this.currentSearchTerm) break;

          const query = this.currentSearchTerm
            ? { code_cont: this.currentSearchTerm }
            : {}; 

          const response = await this.$http.secured.get("/api/v1/products", {
            params: {
              q: query,
              per_page: 50,
              page: this.currentPage
            }
          });

          const newProducts = response.data.products;

          const newUniqueProducts = newProducts.filter(
            np => !this.productList.some(p => p.code === np.code)
          );

          this.productList = [...this.productList, ...newUniqueProducts];

          if (newProducts.length < 30) {
            this.hasMoreResults = false;
          } else {
            this.currentPage += 1;
          }

          foundEnough = this.currentSearchTerm
            ? this.productList.some(p => p.code === this.currentSearchTerm)
            : true; 

        }

      } catch (error) {
        console.error("Erro ao buscar produtos para o multiselect", error);
      } finally {
        this.loadingMore = false;
      }
    },
    async getProductTypes() {
      try {
        const response = await this.$http.secured.get("/api/v1/producttypes", {})
        this.products_type = response.data;
      } catch (error) {
        console.error("[Products][getProductTypes]");
      }
    },
    async getGrupos() {
      try {
        const response = await this.$http.secured.get("/api/v1/grupos")
        this.grupos = response.data;
      } catch (error) {
        console.error("[products][getGrupos]");
      }
    },
    search() {
      const q = this.queryParams; 
      this.filtered = !this.emptyFilter;
      this.setData(q);
    },

    changePage(page) {
      let filterInput = this.filtered ? this.queryParams : null; 
      this.setData(filterInput, page);
    },
    async save() {
      // const validForm = await this.$refs.observer.validate();
       if(!this.validateForm()) {
        return;
       }

      this.product.producttype_id = this.product.producttype_id.id;
      this.product.grupo_id = this.product.grupo_id.id;
      this.product.subgrupo_id = this.product.subgrupo_id.id;
      this.product.status = 'active'

      this.$http.secured
        .post("/api/v1/products", { product: this.product })
        .then(response => {
          this.products.push(response.data);
          this.product.id = response.data.id;
          this.$toasted.global.defaultSuccess();
          this.modals.modal0 = false;
          this.$refs.observer.reset();
          this.filterSimilarLeft = "";
          this.filterSimilarRight = "";
          this.setCultures("left");
          this.setSimilares("left");
          setData(null, null);
          this.$toasted.global.defaultSuccess();
        })
        .catch(error => {
          this.setError(error, "Cannot save Group")
        });
    },
    async execEdit() {
      const validForm = await this.$refs.observer.validate();
      if(!validForm) {
        return;
      }
      this.formProduct.producttype_id = this.formProduct.producttype.id
      this.formProduct.grupo_id = this.formProduct.grupo.id
      this.formProduct.subgrupo_id = this.formProduct.subgrupo.id

      this.$http.secured
        .put(`/api/v1/products/${this.formProduct.id}`, this.formProduct)
        .then(response => {
          this.response = response.data;
          this.$toasted.global.defaultSuccess();
          this.modals.modal1 = false;
          this.formProduct = {};
          this.search();
        })
        .catch(error => this.setError(error, "Cannot update Product"));
    },
    edit(product, modal) {
      this.product = product;
      this.productCultures.id = product.id;
      this.formProduct = Object.assign({}, product);

      if(modal === 'culture'){
        this.setCultures(product.id, undefined, 'left', "" , null);
        this.setCultures(product.id, undefined, 'right', null , "");
        this.modals.modal2 = true;
      }else if(modal === 'similar'){
        this.filterSimilarLeft = "";
        this.filterSimilarRight = "";
        this.setSimilares(product.id, undefined, 'left', "" , null);
        this.setSimilares(product.id, undefined, 'right', null , "");
        this.modals.modal3 = true;
      } else{
        this.modals.modal1 = true;
      }
    },
    emptyObject(object){
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    remove(product) {
      if (
        confirm("Deseja excluir o Produto " + `${product.description}` + "?")
      ) {
        this.$http.secured
          .delete(`/api/v1/products/${product.id}`, product)
          .then(response => {
            this.$toasted.global.defaultSuccess();
            this.setData();
          })
          .catch(error => this.setError(error, "Cannot delete product"));
      }
    },
    setCultures(produto, page, side, filterLeft, filterRight) {
      if (typeof page === "undefined") page = null;
      var q = {};

      if (side === 'left') {
        if (typeof filterLeft == 'string' && filterLeft != '') {
          q.description = filterLeft;
        } else {
          q = null;
        }

        this.$http.secured
          .get("/api/v1/getleftcultures", {
            params: {
              page: page,
              q: q,
              id: produto
            }
          })
          .then(response => {
            this.paginated_cultures_left = response.data;
            this.cultures = this.paginated_cultures_left["cultures"];
          })
          .catch(error => this.setError(error, "Something went wrong"));
      }
      if (side === 'right') {
        if (typeof filterRight == 'string' && filterRight != '') {
          q.description = filterRight;
        } else {
          q = null;
        }

        this.$http.secured
          .get("/api/v1/getrightcultures", {
            params: {
              id: produto,
              q: q
            }
          })
          .then(response => {
            this.allRightCultures = response.data;
            this.updateCultureIds();
          })
          .catch(error => this.setError(error, "Something went wrong"));
      }
    },
    updateCultureIds() {
      const allRightIds = this.allRightCultures.map(cultura => cultura.id);
      this.productCultures.culture_ids = [...new Set([...this.productCultures.culture_ids, ...allRightIds])];
    },
    removeCultures(culturas) {
      if (Array.isArray(culturas)) {
        culturas.forEach(cultura => {
          this.allRightCultures = this.allRightCultures.filter(item => item.id !== cultura.id);
        });
      } else if (culturas && typeof culturas.id !== 'undefined') {
        this.allRightCultures = this.allRightCultures.filter(item => item.id !== culturas.id);
      }
    },
    onTouch (campo) {
      switch(campo) {
        case 'type':
          this.isTouchedType = true;
          break;
        case 'group':
          this.isTouchedGroup = true;
          break;
        case 'subgroup':
          this.isTouchedSubgroup = true;
          break;
      }
    },
    searchEventLeft(search, produto) {
      this.filterCultures = search;

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() => {
        this.setCultures(produto, undefined, 'left', search, null);
      }, 1000);
    },
    searchEventRight(search) {
      this.filterCulturesRight = search;

      if (this.allRightCultures) {
        this.filteredRightCultures = this.allRightCultures.filter(cultura =>
          cultura.description && cultura.description.toLowerCase().includes(search.toLowerCase())
        );

        this.paginatedFilteredRightItems = this.paginatedRightItems(this.filteredRightCultures);
        this.filterCulturesRight = this.paginatedFilteredRightItems.currentPageItems;
      } 
    },
    searchSimilarLeft(search, produto) {
      this.filterSimilarLeft = search;
      this.setSimilares(produto, undefined, 'left', search, null);
    },
    searchSimilarRight(search, produto) {
      this.filterSimilarRight = search;
      this.setSimilares(produto, undefined,'right', null, search);
    },
    changePageLeft(produto, page, filtro) {
      if(filtro){
        this.setCultures(produto, page, 'left', filtro, null);
      }else{
        this.setCultures(produto, page, 'left', "", null);
      }
    },
    changePageRight(page) {
      this.currentPageRight = page
    },
    changePageSimilarLeft(produto, page, filtro) {
      if (filtro) {
        this.setSimilares(produto, page, 'left', filtro, null);
      } else {
        this.setSimilares(produto, page, 'left', "", null);
      }
    },
    changePageSimilarRight(produto, page, filtro) {
      if (filtro) {
        this.setSimilares(produto, page, 'right', null, filtro);
      } else {
        this.setSimilares(produto, page, 'right', null, "");
      }
    },
    setSimilares(produto, page, side, filterLeft, filterRight) {
      if (typeof page === "undefined") page = null;
      var q = {};
      if(side === 'left'){
        if(filterLeft !== "" || typeof page !== "undefined"){
          q.description = filterLeft;
        }else{
          q = null
        }

        this.$http.secured
          .get("/api/v1/getleftsimilar", {
            params: {
              page: page,
              q: q,
              id: produto
            }
          })
          .then(response => {
              this.paginated_products_left = response.data
              this.similarProducts = this.paginated_products_left["products"];
          })
          .catch(error => this.setError(error, "Something went wrong"));
      }
      if(side === 'right'){
        if(filterRight !== "" || typeof page !== "undefined"){
          q.description = filterRight;
        }else{
          q = null;
        }
        this.$http.secured
          .get("/api/v1/getrightsimilar", {
            params: {
              page: page,
              q: q,
              id: produto
            }
          })
          .then(response => {
            this.paginated_products_right = response.data;
            this.similarProductsRight = this.paginated_products_right["products"];
          })
          .catch(error => this.setError(error, "Something went wrong"));
      }
    },
    adicionarSimilar(product_id, products) {
      var produto = {}
      produto.id = product_id;
      if (Array.isArray(products)) {
        products.forEach(product =>  {
          produto.similar_products_attributes = product;
          this.$http.secured
          .put(`/api/v1/products/${product_id}`, {id: product_id, similar_products_attributes: product} )
          .then(response => {
            this.response = response.data;
            if(products[products.length -1].id === product.id){
              if(typeof this.filterSimilarLeft !== "string"){
                this.filterSimilarLeft = "";
              }
              if(typeof this.filterSimilarRight !== "string"){
                this.filterSimilarRight = "";
              }
              this.setSimilares(product_id, null, 'left', "" , null);
              this.setSimilares(product_id, null, 'right', null , "");
            }
          })
          .catch(error => this.setError(error, "Cannot update Product"));
        })
      } else {
        produto.similar_products_attributes = products;
        this.$http.secured
          .put(`/api/v1/products/${produto.id}`, produto)
          .then(response => {
            this.response = response.data;
            if(typeof this.filterSimilarLeft !== "string"){
              this.filterSimilarLeft = "";
            }
            if(typeof this.filterSimilarRight !== "string"){
              this.filterSimilarRight = "";
            }
            this.setSimilares(product_id, null, 'left', "" , null);
            this.setSimilares(product_id, null, 'right', null , "");
          })
          .catch(error => this.setError(error, "Cannot update Product"));
      }
    },
    removerSimilar(product_id, products) {
      var produto = {};
      produto.id = product_id;
     if (Array.isArray(products)) {
        products.forEach(product =>  {
          produto.similar_products_attributes = product;
          this.$http.secured
          .post(`/api/v1/removesimilar`, {id: product_id, similar_products_attributes: product} )
          .then(response => {
            this.response = response.data;
            if(products[products.length -1].id === product.id){
              if(typeof this.filterSimilarLeft !== "string"){
                this.filterSimilarLeft = "";
              }
              if(typeof this.filterSimilarRight !== "string"){
                this.filterSimilarRight = "";
              }
              this.setSimilares(product_id, null, 'left', "" , null);
              this.setSimilares(product_id, null, 'right', null , "");
            }
          })
          .catch(error => this.setError(error, "Cannot update Product"));
        })
      }
      else {
        produto.similar_products_attributes = products;
        this.$http.secured
          .post(`/api/v1/removesimilar`, produto )
          .then(response => {
            this.response = response.data;
            this.filterSimilarLeft = "";
            this.filterSimilarRight = "";
            this.setSimilares(product_id, null, 'left', "" , null);
            this.setSimilares(product_id, null, 'right', null , "");
          })
          .catch(error => this.setError(error, "Cannot update Product"));
      }
    },
    async getSubgrupos() {
      try {
        const response = await this.$http.secured.get("/api/v1/subgrupos")
        this.subgrupos = response.data;
        this.filteredSubgroups = this.subgrupos;
      } catch (error) {
        console.error("[Product][getSubgrupos]", error);
      }
    },
    filterSubgroups(group){
      this.filteredSubgroups = this.subgrupos.filter(e => {
        return e.grupo_ids.indexOf(group.id) != -1
      })
    },
    clearFilters() {
      this.filter = {
        code: '',
        brand: '',
        producttype_id: '',
        grupo_id: '',
        subgrupo_id: '',
        status: '',
        description: ''
      }  
      this.search()
    },
    async getProduct(id) {
      try {
        return await this.$http.secured.get(`/api/v1/products/${id}`);
      } catch (error) {
        this.openGoBackModal = true
      }
    },
    async initRouteProduct(productId) {
      this.isLoading = true;
      const response = await this.getProduct(productId)
      this.isLoading = false;
      if (!response) return;

      const product = response.data
      this.selectedProducts = product
      this.search()
    }
  },
  computed: {
    ...mapState({
      notificationAssociableId: state => state.notificationAssociableId
    }),
    paginatedRightItems() {
      const filteredCultures = this.filterCulturesRight ? this.allRightCultures.filter(cultura =>
        cultura.description && cultura.description.toLowerCase().includes(this.filterCulturesRight.toLowerCase())
      ) : this.allRightCultures
      const itemsPerPage = 10;
      const totalPages   = Math.ceil(filteredCultures.length  / itemsPerPage)
      const startIndex   = (this.currentPageRight - 1) * itemsPerPage;
      const endIndex     = startIndex + itemsPerPage;
      const currentPageItems = filteredCultures.slice(startIndex, endIndex);

      return {
        totalItems: filteredCultures.length,
        totalPages: totalPages,
        currentPage: this.currentPageRight,
        itemsPerPage: itemsPerPage,
        currentPageItems: currentPageItems
      }
    }, 
    queryParams() {
      const q = {};

      if (this.filter.producttype_id && typeof this.filter.producttype_id === "object") {
        q.producttype_id = this.filter.producttype_id.id;
      }
      if (this.filter.grupo_id && typeof this.filter.grupo_id === "object") {
        q.grupo_id = this.filter.grupo_id.id;
      }
      if (this.filter.subgrupo_id && typeof this.filter.subgrupo_id === "object") {
        q.subgrupo_id = this.filter.subgrupo_id.id;
      }

      if (typeof this.filter.producttype_id === "number") {
        delete this.filter.producttype_id;
      }
      if (typeof this.filter.subgrupo_id === "number") {
        delete this.filter.subgrupo_id;
      }
      if (typeof this.filter.grupo_id === "number") {
        delete this.filter.grupo_id;
      }

      if (this.filter.brand) {
        q.brand = this.filter.brand;
      }
      if (this.filter.product) {
        q.code = this.filter.product.code;
      }
      if (this.filter.selectedStatus) {
        q.status = this.filter.selectedStatus.value;
      }
      if (this.filter.description) {
        q.description = this.filter.description;
      }

      return q;
    },
    subGroupIsInvalid(){
      return this.isTouchedSubgroup && !this.product.subgrupo_id
    },
    groupIsInvalid (){
      return this.isTouchedGroup && !this.product.grupo_id
    },
    typeIsInvalid () {
      return this.isTouchedType && !this.product.producttype_id
    },
    emptyFilter: function() {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    "filter.product"(newValue) {
      this.selectedProducts = newValue ? [newValue] : [];
    },
    notificationAssociableId: function (newValue) {
      if (newValue) {
        this.initRouteProduct(newValue);
        this.resetNotificationAction(); // Reset the state to avoid multiple triggers
      }
    }
  }
};
</script>

<style>
.tab-pane {
  padding: 10px;
}
.list-picker-selected {
  background: #61cf8a !important;
}
.button-class {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
  margin-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 50% !important;
}

.button-class img {
  filter: invert(100%);
}

.list-picker-container {
  border-width: 10px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  border-radius: 12px !important;
}

.list-picker-panel {
  border: 1px solid;
  border-color: #ccc;
  border-top: 3px solid;
  border-top-color: #61cf8a;
}

.tituloGrupos {
  background-color: #61cf8a !important;
  box-sizing: border-box !important;
  color: rgb(255, 255, 255) !important;
  display: inline-block !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  height: 30px !important;
  line-height: 17px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 7px !important;
  text-align: left !important;
  text-size-adjust: 100% !important;
  visibility: visible !important;
  /* width: 35% !important; */
  border-radius: 6px 6px 0px 0px;
  border-bottom: 0px !important;
}
.inputLeft {
  width: 97%;
}
.inputRight {
  float: right;
  width: 89%;
}
#multiselect {
  padding: 0px;
  display:inline;
}
</style>